module.exports = __webpack_public_path__ + "static/media/16.74e8a3a6.jpg";